// frontend/src/utils/formatDate.js (Final Version)

export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';

  // Create a date object from the UTC string from our database
  const date = new Date(dateString);

  // Get the user's browser's timezone offset in minutes
  // (e.g., AST is UTC-4, so offset is 240 minutes)
  const timezoneOffset = date.getTimezoneOffset();

  // Create a new date object that is adjusted by the offset.
  // This effectively cancels out the timezone conversion for display purposes.
  const adjustedDate = new Date(date.getTime() + (timezoneOffset * 60000));

  // Options to ensure the output is always DD/MM/YYYY
  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  };

  // Format the *adjusted* date
  return adjustedDate.toLocaleDateString('en-GD', options);
};
